const parseTags = (value) =>
    value
        .split(',')
        .map((tag) => tag.trim())
        .filter(Boolean);

export const addTaskTags = (value, setTaskForm) => {
    const items = parseTags(value);
    if (!items.length) return;
    setTaskForm((prev) => {
        const merged = new Set([...(prev.tags || []), ...items]);
        return { ...prev, tags: Array.from(merged) };
    });
};

export const handleTagsBlur = (taskTagsInput, setTaskTagsInput, addTaskTagsFn) => {
    addTaskTagsFn(taskTagsInput);
    setTaskTagsInput('');
};

export const handleTagsKeyDown = (event, taskTagsInput, setTaskTagsInput, addTaskTagsFn) => {
    if (event.key !== 'Enter') return;
    event.preventDefault();
    addTaskTagsFn(taskTagsInput);
    setTaskTagsInput('');
};

export const addEditTags = (value, setTaskEditForm) => {
    const items = parseTags(value);
    if (!items.length) return;
    setTaskEditForm((prev) => {
        const merged = new Set([...(prev.tags || []), ...items]);
        return { ...prev, tags: Array.from(merged) };
    });
};

export const handleEditTagsBlur = (taskEditTagsInput, setTaskEditTagsInput, addEditTagsFn) => {
    addEditTagsFn(taskEditTagsInput);
    setTaskEditTagsInput('');
};

export const handleEditTagsKeyDown = (event, taskEditTagsInput, setTaskEditTagsInput, addEditTagsFn) => {
    if (event.key !== 'Enter') return;
    event.preventDefault();
    addEditTagsFn(taskEditTagsInput);
    setTaskEditTagsInput('');
};

export const openTaskEdit = (taskDetail, setTaskEditForm, setTaskEditTagsInput, setTaskEditOpen) => {
    if (!taskDetail) return;
    const participants = taskDetail.participants || [];
    const assignee = participants.find((item) => item.role === 'assignee')?.user?.id || '';
    const coAssignees = participants
        .filter((item) => item.role === 'co_assignee')
        .map((item) => item.user?.id)
        .filter(Boolean);
    const watchers = participants
        .filter((item) => item.role === 'watcher')
        .map((item) => item.user?.id)
        .filter(Boolean);
    const cabinets = (taskDetail.cabinets || []).map((item) => item.marketplace_account_id);
    setTaskEditForm({
        created_by_id: taskDetail.created_by_id || '',
        title: taskDetail.title || '',
        description: taskDetail.description || '',
        start_at: taskDetail.start_at ? new Date(taskDetail.start_at).toISOString().slice(0, 16) : '',
        due_at: taskDetail.due_at ? new Date(taskDetail.due_at).toISOString().slice(0, 16) : '',
        notify: taskDetail.notify || false,
        tags: taskDetail.tags || [],
        workspace_id: taskDetail.workspace_id || '',
        assignee_id: assignee,
        assignee_type: taskDetail.assignee_type || 'user',
        ai_agent_slug: taskDetail.ai_agent_slug || '',
        co_assignee_ids: coAssignees,
        watcher_ids: watchers,
        cabinet_ids: cabinets
    });
    setTaskEditTagsInput('');
    setTaskEditOpen(true);
};

export const closeTaskEdit = (setTaskEditOpen) => {
    setTaskEditOpen(false);
};

export const toggleEditList = (key, value, setTaskEditForm) => {
    setTaskEditForm((prev) => {
        const list = new Set(prev[key]);
        if (list.has(value)) {
            list.delete(value);
        } else {
            list.add(value);
        }
        return { ...prev, [key]: Array.from(list) };
    });
};
